export default __webpack_public_path__ + "static/media/splatter-no-1.e891a07d.mid";